<div class="-contact-head" *ngIf="title">
  <lucide-icon name="info" [size]="20"></lucide-icon>
  <h3>{{ title }}</h3>
</div>
<p *ngIf="description" [innerHTML]="description"></p>
<div class="-links" *ngIf="links.length > 0">
  <app-link *ngFor="let item of links" [to]="item.path">{{ item.title }}</app-link>
</div>
